// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Lato);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://weloveiconfonts.com/api/?family=fontawesome);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.speaking {
  display: flex;
  background-color: rgb(244, 244, 244);
}

.wrapper {
  max-width: 750px;
  margin: 0 auto;
  font-family: "Spartan", sans-serif;
}

h1.section-title {
  font-size: 3em;
  padding: 1em 0;
  text-align: center;
  position: relative;
  z-index: 1;
}

h1.section-title span {
  background: #fff;
  padding: 0 0.5em;
}

h1.section-title:before {
  border-top: 2px dashed #999;
  content: "";
  margin: 0 auto;
  /* this centers the line to the full width specified */
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  width: 95%;
  z-index: -1;
}

#more:hover {
  color: #a5e300;
}

.event-title {
  font-size: 1.2em;
}

.event-list-item {
  margin: 1em;
  background: #fafafa;
  border: 1px solid rgba(0, 0, 0, 0.05);
  max-width: 750px;
  max-height: 350px;
  position: relative;
  overflow: hidden;
}

.event-list-item:nth-of-type(even) {
  background: #f5f5f5;
}

.event-info {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.event-info .event-info-extras {
  display: flex;
  flex-flow: row nowrap;
  position: absolute;
  justify-content: flex-end;
  top: 0;
  right: 0;
  font-size: 1.25em;
  padding: 0.3em 0;
}

.event-info .event-info-extras a {
  text-decoration: none;
}

.event-info .event-info-extras .free:after {
  content: "Free";
  background: #5dbf0d;
  color: #fff;
  padding: 0.25em 0.5em;
}

.event-info .event-info-extras .iCal:after {
  content: "\\f073";
  font-family: "Fontawesome";
  font-size: 1.25em;
  color: #0099a9;
  margin: 0.25em 0.25em 0 0;
}

.event-info .event-info-extras .register:after {
  content: "\\f05a";
  font-family: "Fontawesome";
  font-size: 1.25em;
  color: #0099a9;
  margin: 0.25em 0.25em 0 0;
}

.event-info .event-date {
  display: flex;
  flex-flow: column nowrap;
  width: 100px;
  max-width: 100px;
}

.event-info .event-date .event-start,
.event-info .event-date .event-end {
  width: 3em;
  height: 4em;
  text-align: center;
  resize: vertical;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 2em;
  color: #fff;
  background: #ccc;
  align-self: flex-start;
}

.event-info .event-date .event-end {
  margin-top: 0;
}

.event-info .event-date .event-end:before {
  content: "thru";
  font-size: 0.5em;
  position: absolute;
  top: 90px;
  left: 37px;
}

.event-info .event-description {
  max-width: 600px;
  line-height: 1.25em;
  padding: 1.25em;
}

.event-info .event-description .event-header {
  font-size: 1.5em;
  margin-bottom: 0.25em;
}

.event-info .event-description .event-header a {
  text-decoration: none;
  color: #333;
}
.event-info .event-description .event-header a:hover {
  text-decoration: underline;
}

.event-info .event-description .event-header .event-title {
  margin-bottom: 0.25em;
}

.event-info .event-description .event-header .event-location,
.event-info .event-description .event-header .event-time {
  font-size: 0.55em;
}

.event-info .event-description .event-header .event-location:before {
  content: "\\f041";
  font-family: "Fontawesome";
  margin-right: 0.35em;
}

.event-info .event-description .event-header .event-time:before {
  content: "\\f017";
  font-family: "Fontawesome";
  margin-right: 0.35em;
}

.event-info .event-description .event-excerpt {
  font-size: 0.85em;
}

.event-info .event-description .event-excerpt a.more {
  color: #248f8b;
  text-decoration: none;
  text-transform: uppercase;
}

.event-info .event-description .event-excerpt a.more:hover {
  color: #a5e300;
  background-color: #00205c;
}

.event-info .event-description .event-excerpt a.more:after {
  content: "\\f0a9";
  font-family: "Fontawesome";
  margin-left: 0.25em;
}

.event-list-item.featured {
  color: #fff;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);
}

.event-list-item.featured .event-info {
  padding: 3em 2em;
  position: relative;
  z-index: 1;
}

.event-list-item.featured .event-info .event-info-extras .iCal:after {
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}

.event-list-item.featured .event-info .event-info-extras .register:after {
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}

.event-list-item.featured .event-info .event-date {
  max-width: 100px;
  position: relative;
}

.event-list-item.featured .event-info .event-date .event-end {
  margin-top: 1em;
}

.event-list-item.featured .event-info .event-date .event-end:before {
  top: 105px;
  left: 35px;
}

.event-list-item.featured .event-info .event-description {
  max-width: 600px;
  line-height: 1.5em;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.25);
}

.event-list-item.featured .event-info .event-description a {
  text-decoration: none;
  color: #fff;
}

.event-list-item.featured .event-info .event-description .event-header {
  font-size: 2em;
  margin-bottom: 0.5em;
  padding-bottom: 0.5em;
  border-bottom: 4px double rgba(255, 255, 255, 0.5);
}

.event-list-item.featured .event-info .event-description .event-header .event-title {
  margin-bottom: 0.5em;
}

.event-list-item.featured .event-info .event-description .event-header .event-title:before {
  content: "\\f005";
  font-family: "Fontawesome";
  margin-right: 0.35em;
}

.event-list-item.featured .event-info .event-description .event-header .event-location,
.event-list-item.featured .event-info .event-description .event-header .event-time {
  font-size: 0.5em;
}

.event-list-item.featured .event-info .event-description .event-header .event-location:before {
  content: "\\f041";
  font-family: "Fontawesome";
  margin-right: 0.35em;
}

.event-list-item.featured .event-info .event-description .event-header .event-time:before {
  content: "\\f017";
  font-family: "Fontawesome";
  margin-right: 0.35em;
}

.event-list-item.featured .event-info .event-description .event-excerpt {
  font-size: 1em;
}

.event-list-item.featured .event-info .event-description .event-excerpt a {
  color: #ffcc00;
}

.event-list-item.featured .event-image {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.event-list-item.gold .event-start,
.event-list-item.gold .event-end {
  background: #ffcc00 !important;
}

.event-list-item.navy .event-start,
.event-list-item.navy .event-end {
  background: #551fbd !important;
}

.event-list-item.red .event-start,
.event-list-item.red .event-end {
  background: #b30000 !important;
}

.event-list-item.teal .event-start,
.event-list-item.teal .event-end {
  background: #248f8b !important;
}

.event-list-item.featured.gold {
  border-left: 10px solid #ffcc00;
  max-width: 740px;
}

.event-list-item.featured.navy {
  border-left: 10px solid #00205c;
  max-width: 740px;
}

.event-list-item.featured.red {
  border-left: 10px solid #b30000;
  max-width: 740px;
}

.event-list-item.featured.teal {
  border-left: 10px solid #248f8b;
  max-width: 740px;
}

@media (max-width: 500px) {
  .event-title {
    font-size: 1em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Speaking-Events/Speaking.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;AAGF;;AAIA;EACE,gBAAA;EACA,cAAA;EACA,kCAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AADF;;AAGA;EACE,gBAAA;EACA,gBAAA;AAAF;;AAEA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;EACA,sDAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,aAAA;EACA,qBAAA;EACA,2BAAA;AAEF;;AAAA;EACE,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,MAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AAGF;;AADA;EACE,qBAAA;AAIF;;AAFA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AAMF;;AAJA;EACE,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,cAAA;EACA,yBAAA;AAOF;;AALA;EACE,aAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;AAQF;;AANA;;EAEE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AASF;;AAPA;EACE,aAAA;AAUF;;AARA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAWF;;AATA;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;AAYF;;AAVA;EACE,gBAAA;EACA,qBAAA;AAaF;;AAXA;EACE,qBAAA;EACA,WAAA;AAcF;AAZE;EACE,0BAAA;AAcJ;;AAXA;EACE,qBAAA;AAcF;;AAZA;;EAEE,iBAAA;AAeF;;AAbA;EACE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAgBF;;AAdA;EACE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAiBF;;AAfA;EACE,iBAAA;AAkBF;;AAhBA;EACE,cAAA;EACA,qBAAA;EACA,yBAAA;AAmBF;;AAhBA;EACE,cAAA;EACA,yBAAA;AAmBF;;AAhBA;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;AAmBF;;AAhBA;EACE,WAAA;EACA,oFAAA;AAmBF;;AAbA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AAgBF;;AAdA;EACE,WAAA;EACA,yCAAA;AAiBF;;AAfA;EACE,WAAA;EACA,yCAAA;AAkBF;;AAhBA;EACE,gBAAA;EACA,kBAAA;AAmBF;;AAjBA;EACE,eAAA;AAoBF;;AAlBA;EACE,UAAA;EACA,UAAA;AAqBF;;AAnBA;EACE,gBAAA;EACA,kBAAA;EACA,wCAAA;AAsBF;;AApBA;EACE,qBAAA;EACA,WAAA;AAuBF;;AArBA;EACE,cAAA;EACA,oBAAA;EACA,qBAAA;EACA,kDAAA;AAwBF;;AAtBA;EAKE,oBAAA;AAqBF;;AAnBA;EAKE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAkBF;;AAhBA;;EAUE,gBAAA;AAWF;;AATA;EAKE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAQF;;AANA;EAKE,gBAAA;EACA,0BAAA;EACA,oBAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAQF;;AALA;;EAEE,8BAAA;AAQF;;AANA;;EAEE,8BAAA;AASF;;AAPA;;EAEE,8BAAA;AAUF;;AARA;;EAEE,8BAAA;AAWF;;AATA;EACE,+BAAA;EACA,gBAAA;AAYF;;AAVA;EACE,+BAAA;EACA,gBAAA;AAaF;;AAXA;EACE,+BAAA;EACA,gBAAA;AAcF;;AAZA;EACE,+BAAA;EACA,gBAAA;AAeF;;AAZA;EACE;IACE,cAAA;EAeF;AACF","sourcesContent":[".speaking {\n  display: flex;\n  background-color: rgba(244, 244, 244, 1);\n}\n\n@charset \"UTF-8\";\n@import \"https://fonts.googleapis.com/css?family=Lato\";\n@import \"http://weloveiconfonts.com/api/?family=fontawesome\";\n\n.wrapper {\n  max-width: 750px;\n  margin: 0 auto;\n  font-family: \"Spartan\", sans-serif;\n}\n\nh1.section-title {\n  font-size: 3em;\n  padding: 1em 0;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n}\nh1.section-title span {\n  background: #fff;\n  padding: 0 0.5em;\n}\nh1.section-title:before {\n  border-top: 2px dashed #999;\n  content: \"\";\n  margin: 0 auto;\n  /* this centers the line to the full width specified */\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 95%;\n  z-index: -1;\n}\n\n#more:hover {\n  color: #a5e300;\n}\n\n.event-title {\n  font-size: 1.2em;\n}\n\n.event-list-item {\n  margin: 1em;\n  background: #fafafa;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  max-width: 750px;\n  max-height: 350px;\n  position: relative;\n  overflow: hidden;\n}\n.event-list-item:nth-of-type(even) {\n  background: #f5f5f5;\n}\n\n.event-info {\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n}\n.event-info .event-info-extras {\n  display: flex;\n  flex-flow: row nowrap;\n  position: absolute;\n  justify-content: flex-end;\n  top: 0;\n  right: 0;\n  font-size: 1.25em;\n  padding: 0.3em 0;\n}\n.event-info .event-info-extras a {\n  text-decoration: none;\n}\n.event-info .event-info-extras .free:after {\n  content: \"Free\";\n  background: #5dbf0d;\n  color: #fff;\n  padding: 0.25em 0.5em;\n}\n.event-info .event-info-extras .iCal:after {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  font-size: 1.25em;\n  color: #0099a9;\n  margin: 0.25em 0.25em 0 0;\n}\n.event-info .event-info-extras .register:after {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  font-size: 1.25em;\n  color: #0099a9;\n  margin: 0.25em 0.25em 0 0;\n}\n.event-info .event-date {\n  display: flex;\n  flex-flow: column nowrap;\n  width: 100px;\n  max-width: 100px;\n}\n.event-info .event-date .event-start,\n.event-info .event-date .event-end {\n  width: 3em;\n  height: 4em;\n  text-align: center;\n  resize: vertical;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  font-size: 2em;\n  color: #fff;\n  background: #ccc;\n  align-self: flex-start;\n}\n.event-info .event-date .event-end {\n  margin-top: 0;\n}\n.event-info .event-date .event-end:before {\n  content: \"thru\";\n  font-size: 0.5em;\n  position: absolute;\n  top: 90px;\n  left: 37px;\n}\n.event-info .event-description {\n  max-width: 600px;\n  line-height: 1.25em;\n  padding: 1.25em;\n}\n.event-info .event-description .event-header {\n  font-size: 1.5em;\n  margin-bottom: 0.25em;\n}\n.event-info .event-description .event-header a {\n  text-decoration: none;\n  color: #333;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n.event-info .event-description .event-header .event-title {\n  margin-bottom: 0.25em;\n}\n.event-info .event-description .event-header .event-location,\n.event-info .event-description .event-header .event-time {\n  font-size: 0.55em;\n}\n.event-info .event-description .event-header .event-location:before {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-right: 0.35em;\n}\n.event-info .event-description .event-header .event-time:before {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-right: 0.35em;\n}\n.event-info .event-description .event-excerpt {\n  font-size: 0.85em;\n}\n.event-info .event-description .event-excerpt a.more {\n  color: #248f8b;\n  text-decoration: none;\n  text-transform: uppercase;\n}\n\n.event-info .event-description .event-excerpt a.more:hover {\n  color: #a5e300;\n  background-color: #00205c;\n}\n\n.event-info .event-description .event-excerpt a.more:after {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-left: 0.25em;\n}\n\n.event-list-item.featured {\n  color: #fff;\n  background: linear-gradient(\n    to right,\n    rgba(0, 0, 0, 0.75) 0%,\n    rgba(0, 0, 0, 0) 100%\n  );\n}\n.event-list-item.featured .event-info {\n  padding: 3em 2em;\n  position: relative;\n  z-index: 1;\n}\n.event-list-item.featured .event-info .event-info-extras .iCal:after {\n  color: #fff;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n}\n.event-list-item.featured .event-info .event-info-extras .register:after {\n  color: #fff;\n  text-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n}\n.event-list-item.featured .event-info .event-date {\n  max-width: 100px;\n  position: relative;\n}\n.event-list-item.featured .event-info .event-date .event-end {\n  margin-top: 1em;\n}\n.event-list-item.featured .event-info .event-date .event-end:before {\n  top: 105px;\n  left: 35px;\n}\n.event-list-item.featured .event-info .event-description {\n  max-width: 600px;\n  line-height: 1.5em;\n  text-shadow: 0 0 5px rgba(0, 0, 0, 0.25);\n}\n.event-list-item.featured .event-info .event-description a {\n  text-decoration: none;\n  color: #fff;\n}\n.event-list-item.featured .event-info .event-description .event-header {\n  font-size: 2em;\n  margin-bottom: 0.5em;\n  padding-bottom: 0.5em;\n  border-bottom: 4px double rgba(255, 255, 255, 0.5);\n}\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-title {\n  margin-bottom: 0.5em;\n}\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-title:before {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-right: 0.35em;\n}\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-location,\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-time {\n  font-size: 0.5em;\n}\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-location:before {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-right: 0.35em;\n}\n.event-list-item.featured\n  .event-info\n  .event-description\n  .event-header\n  .event-time:before {\n  content: \"\";\n  font-family: \"Fontawesome\";\n  margin-right: 0.35em;\n}\n.event-list-item.featured .event-info .event-description .event-excerpt {\n  font-size: 1em;\n}\n.event-list-item.featured .event-info .event-description .event-excerpt a {\n  color: #ffcc00;\n}\n.event-list-item.featured .event-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.event-list-item.gold .event-start,\n.event-list-item.gold .event-end {\n  background: #ffcc00 !important;\n}\n.event-list-item.navy .event-start,\n.event-list-item.navy .event-end {\n  background: #551fbd !important;\n}\n.event-list-item.red .event-start,\n.event-list-item.red .event-end {\n  background: #b30000 !important;\n}\n.event-list-item.teal .event-start,\n.event-list-item.teal .event-end {\n  background: #248f8b !important;\n}\n.event-list-item.featured.gold {\n  border-left: 10px solid #ffcc00;\n  max-width: 740px;\n}\n.event-list-item.featured.navy {\n  border-left: 10px solid #00205c;\n  max-width: 740px;\n}\n.event-list-item.featured.red {\n  border-left: 10px solid #b30000;\n  max-width: 740px;\n}\n.event-list-item.featured.teal {\n  border-left: 10px solid #248f8b;\n  max-width: 740px;\n}\n\n@media (max-width: 500px) {\n  .event-title {\n    font-size: 1em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
